import { useEffect, useState } from "react";
import { CHANNEL_DEFAULT_IMAGE_DATA_URI } from "../Utils/assets";

const useChannelProfileImg = (
    publicUrl: string | undefined,
    profileImage: string | undefined
): string => {
    const [channelProfileImages, setChannelProfileImage] = useState(
        CHANNEL_DEFAULT_IMAGE_DATA_URI
    );

    useEffect(() => {
        if (profileImage && publicUrl) {
            setChannelProfileImage(`${publicUrl}/${profileImage}`);
            return;
        }

        setChannelProfileImage(CHANNEL_DEFAULT_IMAGE_DATA_URI);
    }, [profileImage, publicUrl]);

    return channelProfileImages;
};

export default useChannelProfileImg;
